
<template>
<div>

 
  <v-footer padless class="mt-5" >
    <v-row class="main-footer" style="margin-top:5px;">
      <v-col >
        <h2 class="footer-heading-1">
          AUROVILLE CONSULTING
          <div class="header-note">A UNIT OF THE AUROVILLE FOUNDATION</div>
        </h2>
        <div class="contact-address" style="margin-top: -10px;">
          <div class="address-details">
            <v-icon size="20px">mdi-map-marker</v-icon>
            Kalpana, Crown Road, Irumbai Post, <br />
            <span class="ml-6"> Auroville TN 605101, India </span>
          </div>
          <div class="address-details">
            <v-icon  size="20px"> mdi-phone </v-icon> +91 (0413) 2622 571
          </div>
          <div class="address-details">
            <a class="link" href="mailto:info@aurovilleconsulting.com">
              <v-icon  size="20px"> mdi-email </v-icon> info@aurovilleconsulting.com </a>
          </div>
        </div>
      </v-col>
      <v-col style="padding-right:8%">
      <div style="position:relative">
        <h2 class="footer-heading-1">ABOUT US</h2>
        <div class="contact-address" style="margin-top:35px">
          The Solva is managed by Auroville Consulting. Auroville Consulting is
          a unit of the Auroville Foundation and works to establish a prosperous
          eco-system that supports all life on this planet.
        </div>
      </div>
      </v-col>
      <v-col>
        <h2 class="footer-heading-1" >USEFUL LINKS</h2>
        <div style="margin-top:35px"></div>
        <div class="contact-address"  v-for="item in usefullLinks" :key="item.text">
           <v-icon size="5px" style="padding-right: 6px">
              mdi-checkbox-blank-circle
            </v-icon>
            <a
              class="link"
              target="_blank"
              rel="noopener noreferrer"
              :href="item.link"
              >{{item.text}}</a
          ><br />
        </div>
      </v-col>

   
    </v-row>
 
 <v-row class="main-footer social-media" style="max-width:78%; margin-top: -10px;">
  <v-col>
    <v-row  no wrap>
        <v-card height="25px"
          v-for="item in socialMedia" :key="item.icon"
          flat
          class="d-flex align-center justify-center menu-border ml-3">

          <a :href="item.link" target="_blank"  rel="noopener noreferrer" class="link">
            <v-icon v-text="item.icon" size="15px" style="padding:2px"/>
          </a>
          </v-card> 

       
      </v-row>
  </v-col>
  <v-col class="main-footer" style="margin-left: auto;">
     
            <v-btn
            id = "subscribeBtn"
            class="button text-none  contact-address"
            style="margin-top:-35px"
            text
            @click="showNewsLetterModal = true"
            >Subscribe to our newsletter</v-btn
          >
       
  </v-col>
  <v-col></v-col>


 </v-row>
     


    <NewsLetter
      :visible="showNewsLetterModal"
      @onClose="showNewsLetterModal = false"
    />
 
  </v-footer>
   <v-row  style="background-color:#F6F6F6; padding-left: 335px;">
       <v-col class="mt-10 mb-2 text-caption footer">
        <router-link to="/termsandcondition" class="link">TERMS AND CONDITIONS</router-link>
      </v-col>
      <v-col class="mt-10 mb-2 text-caption main-footer footer">
          © 2022 AUROVILLE CONSULTING | ALL RIGHTS RESERVED
      </v-col>
    </v-row >
  </div>
</template>
<script>
import FooterStore from "@/services/footerstore";
import NewsLetter from "@/components/NewsLetter.vue";
import webContent from "@/libs/webContent.js";
// import UsefullLinks from "@/components/NewsLetter.vue";

export default {
  name: "Footer",
  data: () => ({
    showNewsLetterModal: false,
    footerData: FooterStore.data.Footer,
    lg: 3,
    md: 4,
    cols: 12,
    links: [],
    usefullLinks:[],
    socialMedia:[],
  }),
  components: { NewsLetter },
  created(){
    this.getSocialMedia();
    this.getUsefullLinks();
  },
  methods:{
    getLinks() {
      this.links = webContent.getLinks();
    },
    getSocialMedia(){
       this.socialMedia = webContent.getSocialMedia();
    },
     getUsefullLinks(){
       this.usefullLinks = webContent.getUsefullLinks();
    }
  }
};
</script>
<style scoped>
.link {
  text-decoration: none;
  color: grey !important;
}
/* .links > a {
  text-decoration: none;
  color: grey !important;
} */
.main-footer {
  margin-left: 17%;
 
  /* margin-left: auto;
  margin-right: auto; */
}
a:hover {
  color: rgb(236, 121, 6) !important;
}
.header-note {
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.3px;
}
.footer-heading-1 {
  padding-top: 20px;
  margin-bottom: 25px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 1.3px;
}
.contact-title {
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.3px;
}
.contact-address {
  font-size: 13px;
  font-weight: 300;
  line-height: 20px;
}
.footer-heading-2 {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 1.3px;
}
.address-details {
  padding-bottom: 10px;
}
.social-media {
  padding-top: 10px;
  width: 63%;
}
.menu-border {
  border: 1px solid rgb(101, 100, 100);
  border-radius: 10px;
  margin: 1 0px;
  padding: 2px;
}
 .button:hover {
   
      color:white;
      transition: 0.4s;
  }
  .button { 
      background-color:#4b9b40;
      color:white;

  }
  .subscrib-btn{
    margin: auto;
    /* margin-top: 13% ; */
    position: absolute; 
  }
</style>